import { Helmet } from "react-helmet";
import { FaClock, FaMapMarkerAlt, FaPhone, FaWhatsapp } from "react-icons/fa";

function Contact() {
  const phoneNumber = "905349214602";
  const defaultMessage =
    "Merhaba Dr. Tayfun Bey, web sitenizden ulaşıyorum. Danışmak istediğim konular hakkında bilgi almak istiyorum.";

  // 1. Doğrudan arama için tel: bağlantısı
  const telUrl = `tel:+${phoneNumber}`;

  // 2. WhatsApp bağlantısı
  // Contact.js dosyasında:
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
    defaultMessage
  )}`;

  return (
    <section id="contact">
      <Helmet>
        <title>
          İletişim & Randevu | Dr. Tayfun Giyik | Bakırköy, İstanbul
        </title>
        <meta
          name="description"
          content="Dr. Tayfun Giyik ile iletişime geçin. Bakırköy, İstanbul'daki kliniğimizden randevu alın. WhatsApp, telefon ve harita bilgileri."
        />
        <link
          rel="canonical"
          href="https://www.drtayfungiyik.com.tr/iletisim"
        />
        <meta property="og:title" content="İletişim & Randevu" />
        <meta
          property="og:description"
          content="Randevu almak için iletişime geçin."
        />
      </Helmet>
      <h2 className="section-title">İletişim & Randevu</h2>

      <div className="contact-wrapper">
        {/* SOL TARAF: İletişim Bilgileri */}
        <div className="contact-info">
          <div className="info-item">
            <div className="icon">
              <FaWhatsapp />
            </div>
            <div>
              <h3>WhatsApp</h3>
              <p>+90 534 921 46 02</p>
              <a
                href={whatsappUrl}
                className="whatsapp-button"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  background: "#25D366",
                  color: "white",
                  padding: "10px 20px",
                  borderRadius: "50px",
                  textDecoration: "none",
                  marginTop: "10px",
                  fontWeight: "600",
                }}
              >
                <FaWhatsapp style={{ marginRight: "8px" }} /> Mesaj Gönder
              </a>
            </div>
          </div>

          <div className="info-item">
            <div className="icon">
              <FaPhone />
            </div>
            <div>
              <h3>Telefon</h3>
              <p>
                <a
                  href={telUrl}
                  style={{ color: "#1a5276", textDecoration: "none" }}
                >
                  +90 534 921 46 02
                </a>
              </p>
              <p
                style={{ fontSize: "0.9rem", color: "#666", marginTop: "5px" }}
              >
                Arayarak da randevu oluşturabilirsiniz.
              </p>
            </div>
          </div>

          <div className="info-item">
            <div className="icon">
              <FaMapMarkerAlt />
            </div>
            <div>
              <h3>Adres</h3>
              <p>
                Zuhuratbaba Mahallesi, İncirli Caddesi 89/3 <br />
                Bakırköy, Istanbul, Turkey 34147
              </p>
              <p
                style={{ fontSize: "0.9rem", color: "#666", marginTop: "5px" }}
              >
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Zuhuratbaba+Mahallesi%2C+İncirli+Caddesi+89%2F3%2C+Bakırköy%2C+İstanbul%2C+34147"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#d4af37" }}
                >
                  Haritada Görüntüle →
                </a>
              </p>
            </div>
          </div>

          <div className="info-item">
            <div className="icon">
              <FaClock />
            </div>
            <div>
              <h3>Çalışma Saatleri</h3>
              <p>Pazartesi - Cuma: 10:00 - 19:00</p>
              <p>Cumartesi: 10:00 - 17:00</p>
            </div>
          </div>
        </div>

        {/* SAĞ TARAF: WhatsApp Hızlı İletişim Kutusu */}
        <div
          className="whatsapp-box"
          style={{
            background: "#f0f9ff",
            padding: "2rem",
            borderRadius: "10px",
            border: "1px solid #cce7ff",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
            <FaWhatsapp style={{ fontSize: "3rem", color: "#25D366" }} />
            <h3 style={{ color: "#1a5276", marginTop: "1rem" }}>
              Hızlı WhatsApp İletişimi
            </h3>
            <p style={{ color: "#666" }}>
              Tıklayın, mesaj otomatik hazırlansın, siz sadece gönderin!
            </p>
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <a
              href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
                "Botoks hakkında bilgi almak istiyorum."
              )}`}
              className="whatsapp-option-button"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: "white",
                padding: "15px",
                borderRadius: "8px",
                textDecoration: "none",
                color: "#333",
                border: "1px solid #ddd",
                textAlign: "center",
                transition: "all 0.3s",
              }}
              onMouseOver={(e) => (e.target.style.background = "#f5f5f5")}
              onMouseOut={(e) => (e.target.style.background = "white")}
            >
              <strong>🤔 Botoks Danışmanlığı</strong>
              <br />
              <small>Fiyat, süreç, etki süresi hakkında</small>
            </a>

            <a
              href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
                "Yüz dolgusu için randevu almak istiyorum."
              )}`}
              className="whatsapp-option-button"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: "white",
                padding: "15px",
                borderRadius: "8px",
                textDecoration: "none",
                color: "#333",
                border: "1px solid #ddd",
                textAlign: "center",
                transition: "all 0.3s",
              }}
              onMouseOver={(e) => (e.target.style.background = "#f5f5f5")}
              onMouseOut={(e) => (e.target.style.background = "white")}
            >
              <strong>💉 Dolgu Uygulamaları</strong>
              <br />
              <small>Hangi dolgu? Fiyat bilgisi?</small>
            </a>

            <a
              href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
                "Genel medikal estetik danışmanlık için görüşmek istiyorum."
              )}`}
              className="whatsapp-option-button"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: "white",
                padding: "15px",
                borderRadius: "8px",
                textDecoration: "none",
                color: "#333",
                border: "1px solid #ddd",
                textAlign: "center",
                transition: "all 0.3s",
              }}
              onMouseOver={(e) => (e.target.style.background = "#f5f5f5")}
              onMouseOut={(e) => (e.target.style.background = "white")}
            >
              <strong>👨‍⚕️ Genel Danışmanlık</strong>
              <br />
              <small>Hangi işlem bana uygun? Ön görüşme</small>
            </a>
          </div>

          <p
            style={{
              fontSize: "0.9rem",
              color: "#666",
              marginTop: "1.5rem",
              textAlign: "center",
              fontStyle: "italic",
            }}
          >
            📞 Aynı numaradan telefonla da ulaşabilirsiniz.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Contact;
